import script from "./AccountingView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__